const initial = {
  studentEnrollmentId: null,
  enrolmentNumber: "",
  studentBookingId: null,
  usiNumber: "",
  usiPermissionGranted: false,
  firstName: "",
  middleName: "",
  lastName: "",
  title: "",
  titleId: 0,
  dateOfBirth: "",
  gender: "",
  genderId: "",
  homePhone: "",
  workPhone: "",
  mobileNumber: "",
  email: "",
  preferredContactTypeId: "",
  buildingPropertyName: "",
  flatUnitDetails: "",
  addressLine1: "",
  streetNumber: "",
  streetName: "",
  suburb: "",
  postCode: "",
  state: "",
  stateId: 0,
  cityId: null,
  countryId: null,
  sameAsResidential: null,
  postalBuildingPropertyName: "",
  postalFlatUnitDetails: "",
  postalStreetNumber: "",
  postalStreetName: "",
  postalAddressLine1: "",
  postalSuburb: "",
  postalPostCode: "",
  postalState: "",
  postalStateId: 0,
  postalCityId: null,
  postalCountryId: null,
  emergencyContactName: "",
  emergencyRelationship: "",
  emergencyContactRelationshipId: null,
  emergencyPhone: "",
  emergencyMobile: "",
  countryOfBirth: "",
  countryOfBirthId: 0,
  townOfBirth: "",
  australianCitizen: "",
  indigenousStatus: "",
  indigenousStatusId: "",
  speakOtherLanguage: "",
  otherLanguage: "",
  englishProficiency: "",
  englishProficiencyId: 0,
  completedYear12: "",
  highestSchoolLevel: "",
  highestSchoolLevelId: 0,
  schoolCountryId: null,
  schoolCompletedYear: "",
  stillAttendingSecondarySchool: "",
  highestQualificationIds: [],
  priorEducationNote: "",
  ableToCompleteQualification: "",
  qualificationCompletedYear: "",
  hasConcessionCard: "",
  concessionCardNumber: "",
  employmentStatusId: "",
  occupation: "",
  employmentStartDate: "",
  workingHoursPerWeek: "",
  employerName: "",
  disabilityFlag: "",
  disabilityTypeIds: [],
  studyReasonIds: [],
  disabilitySupportRequired: "",
  howDidYouHear: "",
  courseEntryRequirementsMet: null,
  courseEntryEvidenceAttached: null,
  reasonableAdjustment: "",
  canReadWriteEnglish: "",
  deliveryFaceToFaceSuitable: "",
  deliveryWorkplaceSuitable: "",
  deliveryTrainerSupportSuitable: "",
  deliveryAssessmentRemarks: "",
  rplOrCreditTransferRequested: "",
  llnSupportRequired: "",
  usiDeclarationAccepted: false,
  declarationAccepted: false,
  studentSignature: "",
  clientName: "",
  clientSignatureText: "",
  clientSignatureDate: "",
  clientSignatureDataUrl: "",
  clientSignatureDocumentId: null,
  clientSignatureViewUrl: "",
  removeClientSignature: false,
  staffEvidenceSubmitted: "",
  staffEntryRequirementsSatisfied: "",
  staffOutcomeNotified: "",
  staffName: "",
  staffSignatureText: "",
  staffSignatureDate: "",
  staffSignatureDataUrl: "",
  staffSignatureDocumentId: null,
  staffSignatureViewUrl: "",
  removeStaffSignature: false,
  activeSection: "personal",
};

const stateNameById = {
  1: "VIC",
  2: "VIC",
  3: "NSW",
  4: "QLD",
  5: "WA",
  6: "SA",
  7: "TAS",
  8: "NT",
  9: "ACT",
};

import { YES_NO } from "@/constants/yesNo";

const yesNoValue = (value) => Number(value) === YES_NO.YES;
const boolToChoice = (value) => value === null || value === undefined ? "" : value === true ? YES_NO.YES : YES_NO.NO;
const textValue = (value) => (value === null || value === undefined ? "" : String(value));
const dateInputValue = (value) => textValue(value).slice(0, 10);
const dateTimeLocalValue = (value) => {
  const date = textValue(value);
  return !date || date.startsWith("0001-01-01") ? "" : date.slice(0, 16);
};
const dateTimeOffsetValue = (value) => {
  const date = textValue(value).trim();
  if (!date) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return `${date}T00:00:00+00:00`;
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(date)) return `${date}:00+00:00`;
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(date)) return `${date}+00:00`;
  return date;
};
const nullableInteger = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isInteger(number) ? number : null;
};
const getFirstDefined = (source, keys = []) => {
  if (!source || typeof source !== "object") return "";

  const normalizedSource = Object.keys(source).reduce((acc, key) => {
    acc[String(key).toLowerCase()] = source[key];
    return acc;
  }, {});

  for (const key of keys) {
    const normalizedKey = String(key).toLowerCase();
    const value = normalizedSource[normalizedKey];
    if (value !== undefined && value !== null && value !== "") return value;
  }
  return "";
};
const optionId = (option) => getFirstDefined(option, ["id", "value", "employmentStatusId"]);
const optionName = (option) => getFirstDefined(option, ["name", "label", "text", "employmentStatusName"]);
const optionCode = (option) => getFirstDefined(option, ["code", "key"]);
const getOptionId = (value, options = [], fallbackValue) => {
  const normalizedValue = textValue(value).trim();
  if (!normalizedValue || normalizedValue === "0") {
    const fallback = textValue(fallbackValue).trim();
    if (!fallback || fallback === "0") return "";
    const match = options.find((option) =>
      String(optionId(option)) === fallback
      || String(optionName(option)).toLowerCase() === fallback.toLowerCase()
      || String(optionCode(option)).toLowerCase() === fallback.toLowerCase());
    return match ? String(optionId(match)) : "";
  }
  if (options.some((option) => String(optionId(option)) === normalizedValue)) return normalizedValue;
  const matchValue = String(fallbackValue ?? value).toLowerCase();
  const match = options.find((option) =>
    String(optionName(option)).toLowerCase() === matchValue
    || String(optionCode(option)).toLowerCase() === matchValue);
  return match ? String(optionId(match)) : "";
};
const getOptionName = (value, options = [], fallbackValue) => {
  const normalizedValue = textValue(value).trim();
  if (normalizedValue && normalizedValue !== "0") {
    const byId = options.find((option) => String(optionId(option)) === normalizedValue);
    if (byId) return textValue(optionName(byId));
    const byName = options.find((option) =>
      String(optionName(option)).toLowerCase() === normalizedValue.toLowerCase()
      || String(optionCode(option)).toLowerCase() === normalizedValue.toLowerCase());
    if (byName) return textValue(optionName(byName));
  }
  const fallback = textValue(fallbackValue).trim();
  return fallback && fallback !== "0" ? fallback : "";
};
const parseStreetAddress = (addressLine1 = "") => {
  const normalized = textValue(addressLine1).trim();
  const match = normalized.match(/^(\d+)\s*(.*)$/);
  if (!match) return { streetNumber: "", streetName: normalized };
  return { streetNumber: match[1], streetName: match[2].trim() };
};

const requiredEnrollmentFields = [
  "usiNumber", "firstName", "lastName", "dateOfBirth", "genderId", "mobileNumber", "email",
  "emergencyContactName",
  "addressLine1", "suburb", "postCode", "stateId", "countryId",
  "sameAsResidential", "indigenousStatusId", "speakOtherLanguage",
  "englishProficiencyId", "highestSchoolLevelId", "schoolCompletedYear",
  "ableToCompleteQualification",
  "disabilityFlag", "howDidYouHear",
  "usiDeclarationAccepted", "declarationAccepted",
];

const hasCompletedValue = (value) => {
  if (typeof value === "string") return value.trim().length > 0;
  if (typeof value === "number") return value > 0;
  return value !== null && value !== undefined && value !== false;
};
const requiredYesNoFields = new Set([
  "speakOtherLanguage", "courseEntryRequirementsMet", "stillAttendingSecondarySchool",
  "ableToCompleteQualification", "disabilityFlag", "reasonableAdjustment",
  "canReadWriteEnglish", "deliveryFaceToFaceSuitable", "deliveryWorkplaceSuitable",
]);
const hasAnsweredYesNo = (value) => value !== "" && value !== null && value !== undefined && !Number.isNaN(Number(value));
const isSameAsResidentialAnswered = (form) => typeof form?.sameAsResidential === "boolean" || form?.sameAsResidential === null;
const serverOnlyEnrollmentProgressFields = new Set(["driverLicenceDocument", "sameAsResidential"]);

function normalizeServerRequiredFields(serverRequiredFields = []) {
  if (!Array.isArray(serverRequiredFields) || serverRequiredFields.length === 0) return [];

  const normalized = [];
  let shouldRequireLanguageAtHome = false;

  serverRequiredFields.forEach((field) => {
    const fieldKey = String(field?.fieldKey ?? field?.FieldKey ?? "");
    if (!fieldKey) return;

    if (serverOnlyEnrollmentProgressFields.has(fieldKey)) {
      return;
    }

    if (fieldKey === "speakOtherLanguage") {
      shouldRequireLanguageAtHome = Boolean(field?.isRequired ?? field?.IsRequired);
      return;
    }

    normalized.push({
      fieldKey,
      fieldName: String(field?.fieldName ?? field?.FieldName ?? fieldKey),
      isRequired: Boolean(field?.isRequired ?? field?.IsRequired),
      isDocument: Boolean(field?.isDocument ?? field?.IsDocument),
    });
  });

  if (shouldRequireLanguageAtHome) {
    const existingLanguageField = normalized.find((field) => field.fieldKey === "otherLanguage");
    if (existingLanguageField) {
      existingLanguageField.isRequired = true;
    } else {
      normalized.push({
        fieldKey: "otherLanguage",
        fieldName: "Language Spoken at home",
        isRequired: true,
        isDocument: false,
      });
    }
  }

  return normalized;
}

function normalizeRequiredFields(form, serverRequiredFields = []) {
  const normalizedServerFields = Array.isArray(serverRequiredFields) && serverRequiredFields.length > 0
    ? normalizeServerRequiredFields(serverRequiredFields)
    : [
      ...requiredEnrollmentFields.map((fieldKey) => ({ fieldKey, fieldName: fieldKey, isRequired: true, isDocument: false })),
      { fieldKey: "driverLicenceDocument", fieldName: "driverLicenceDocument", isRequired: true, isDocument: true },
      { fieldKey: "postalStreetNumber", fieldName: "postalStreetNumber", isRequired: false, isDocument: false },
      { fieldKey: "postalStreetName", fieldName: "postalStreetName", isRequired: false, isDocument: false },
      { fieldKey: "postalSuburb", fieldName: "postalSuburb", isRequired: false, isDocument: false },
      { fieldKey: "postalStateId", fieldName: "postalStateId", isRequired: false, isDocument: false },
      { fieldKey: "postalPostCode", fieldName: "postalPostCode", isRequired: false, isDocument: false },
      { fieldKey: "postalCountryId", fieldName: "postalCountryId", isRequired: false, isDocument: false },
      { fieldKey: "otherLanguage", fieldName: "otherLanguage", isRequired: false, isDocument: false },
    ];

  return normalizedServerFields.map((field) => {
    if (field.fieldKey === "sameAsResidential") {
      return { ...field, isCompleted: isSameAsResidentialAnswered(form) };
    }
    if (field.fieldKey.startsWith("postal")) {
      return { ...field, isRequired: form?.sameAsResidential === false };
    }
    if (field.fieldKey === "otherLanguage") {
      return { ...field, isRequired: yesNoValue(form?.speakOtherLanguage) };
    }
    if (requiredYesNoFields.has(field.fieldKey)) {
      return { ...field, isCompleted: hasAnsweredYesNo(form?.[field.fieldKey]) };
    }
    return { ...field, isCompleted: hasCompletedValue(form?.[field.fieldKey]) };
  }).map((field) => {
    if (field.isCompleted !== undefined) return field;
    if (field.isDocument) return field;
    return { ...field, isCompleted: hasCompletedValue(form?.[field.fieldKey]) };
  });
}

export function getEnrollmentProgress(form, documents = [], serverRequiredFields = []) {
  const fields = normalizeRequiredFields(form, serverRequiredFields);

  const requiredFormFields = fields.filter((field) => field.isRequired && !field.isDocument);
  const requiredDocuments = fields.filter((field) => field.isRequired && field.isDocument);
  const done = requiredFormFields.filter((field) => field.isCompleted).length;
  const completedDocuments = requiredDocuments.filter((field) => {
    if (field.fieldKey !== "driverLicenceDocument") {
      return false;
    }
    return documents.some((document) => Number(document?.studentDocTypeId) === STUDENT_DOCUMENT_TYPES.DRIVER_LICENCE
      && Boolean(document?.file || document?.fileName));
  }).length;
  const total = requiredFormFields.length + requiredDocuments.length;

  return {
    done: done + completedDocuments,
    total,
    percentage: total === 0 ? 0 : Math.round(((done + completedDocuments) / total) * 100),
  };
}

export function getIncompleteRequiredFields(form, documents = [], serverRequiredFields = []) {
  const fields = normalizeRequiredFields(form, serverRequiredFields);
  const missingFields = fields.filter((field) => field.isRequired && !field.isDocument && !field.isCompleted);
  const hasDriverLicence = documents.some((document) => Number(document?.studentDocTypeId) === STUDENT_DOCUMENT_TYPES.DRIVER_LICENCE
    && Boolean(document?.file || document?.fileName));

  if (!hasDriverLicence && fields.some((field) => field.isRequired && field.isDocument && field.fieldKey === "driverLicenceDocument")) {
    missingFields.push({ fieldKey: "driverLicenceDocument", fieldName: "Driver licence document", isRequired: true, isDocument: true, isCompleted: false });
  }

  return missingFields;
}

export function getEnrollmentValidationErrors(form) {
  const errors = [];
  const requireValue = (field, label) => {
    const isComplete = field === "sameAsResidential"
      ? typeof form?.sameAsResidential === "boolean"
      : requiredYesNoFields.has(field)
      ? hasAnsweredYesNo(form?.[field])
      : hasCompletedValue(form?.[field]);
    if (!isComplete) errors.push(`${label} is required.`);
  };

  [
    ["usiNumber", "USI number"], ["firstName", "First name"], ["lastName", "Last name"],
    ["dateOfBirth", "Date of birth"], ["genderId", "Gender"],
    ["mobileNumber", "Mobile number"], ["email", "Email"],
    ["emergencyContactName", "Emergency contact name"],
    ["addressLine1", "Address"], ["suburb", "Suburb/locality"],
    ["stateId", "State/territory"], ["countryId", "Country"], ["postCode", "Postcode"],
    ["sameAsResidential", "Postal address selection"],
    ["countryOfBirthId", "Country of birth"], ["indigenousStatusId", "Indigenous status"],
    ["speakOtherLanguage", "Other-language selection"], ["englishProficiencyId", "English proficiency"],
    ["highestSchoolLevelId", "Highest school level"],
    ["schoolCompletedYear", "School completion year"], ["ableToCompleteQualification", "Qualification completion selection"],
    ["stillAttendingSecondarySchool", "Secondary school attendance selection"],
    ["courseEntryRequirementsMet", "Course entry requirements selection"],
    ["disabilityFlag", "Disability selection"], ["reasonableAdjustment", "Training completion selection"],
    ["canReadWriteEnglish", "Reading, writing or maths help selection"],
    ["deliveryFaceToFaceSuitable", "Face-to-face delivery selection"],
    ["deliveryWorkplaceSuitable", "Online learning delivery selection"],
    ["howDidYouHear", "Course referral source"],
  ].forEach(([field, label]) => requireValue(field, label));

  if (form?.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.push("Enter a valid email address.");
  if (form?.postCode && !/^\d{4}$/.test(form.postCode)) errors.push("Residential postcode must contain four digits.");
  if (yesNoValue(form?.ableToCompleteQualification) && !(form.highestQualificationIds || []).length) errors.push("Select at least one completed qualification.");
  if (form?.sameAsResidential === false) {
    [["postalStreetNumber", "Postal street number"], ["postalStreetName", "Postal street name"],
      ["postalSuburb", "Postal suburb/locality"], ["postalStateId", "Postal state/territory"],
      ["postalCountryId", "Postal country"], ["postalPostCode", "Postal postcode"]]
      .forEach(([field, label]) => requireValue(field, label));
    if (form.postalPostCode && !/^\d{4}$/.test(form.postalPostCode)) errors.push("Postal postcode must contain four digits.");
  }
  if (yesNoValue(form?.speakOtherLanguage)) requireValue("otherLanguage", "Other language");
  if (yesNoValue(form?.disabilityFlag) && !(form.disabilityTypeIds || []).length) errors.push("Select at least one disability type.");
  if (!form?.usiDeclarationAccepted) errors.push("Confirm the USI declaration.");
  if (!form?.declarationAccepted) errors.push("Accept the enrolment declaration.");
  return errors;
}

const enrollmentSectionSteps = {
  usi: 1,
  personal: 2,
  language: 3,
  schooling: 4,
  education: 5,
  employment: 6,
  disability: 7,
  study: 8,
  lln: 9,
  declaration: 10,
};

export function mapStudentProfileToFormState(profile, master = {}) {
  if (!profile) return {};

  const streetAddress = parseStreetAddress(profile.addressLine1);
  const genderOptions = master?.genders || [];
  const cityOptions = master?.cities || [];
  const relationshipOptions = master?.emergencyRelationships || [];

  return {
    usiNumber: textValue(profile.usiNumber),
    firstName: textValue(profile.firstName),
    lastName: textValue(profile.lastName),
    dateOfBirth: dateInputValue(profile.dateOfBirth),
    gender: getOptionName(profile.genderId, genderOptions),
    genderId: getOptionId(profile.genderId, genderOptions),
    mobileNumber: textValue(profile.mobileNumber),
    email: textValue(profile.email),
    flatUnitDetails: textValue(profile.addressLine2),
    streetNumber: streetAddress.streetNumber,
    streetName: streetAddress.streetName,
    suburb: textValue(profile.suburb),
    postCode: textValue(profile.postCode),
    stateId: profile.stateId ? String(profile.stateId) : "",
    cityId: getOptionId("", cityOptions, profile.city) || null,
    countryId: profile.countryId || null,
    emergencyContactName: textValue(profile.emergencyContactName),
    emergencyRelationship: getOptionName(profile.emergencyContactRelationshipId, relationshipOptions),
    emergencyContactRelationshipId: profile.emergencyContactRelationshipId || null,
    emergencyPhone: textValue(profile.emergencyContactNumber),
  };
}

export function mapEnrollmentPayloadToFormState(payload) {
  const studentEnrollment = payload?.studentEnrollment || payload?.enrollment || {};
  const master = payload?.masterData || {};
  const addressLine1Value = getFirstDefined(studentEnrollment, ["addressLine1", "streetAddress", "streetAddressLine1", "streetAddress1"]);
  const streetNoValue = getFirstDefined(studentEnrollment, ["streetNo", "streetNumber", "streetNumber", "streetNumberNo"]);
  const streetNameValue = getFirstDefined(studentEnrollment, ["streetName", "streetName", "streetAddressName", "street"]);
  const combinedAddress = [streetNoValue, streetNameValue].filter(Boolean).join(" ") || addressLine1Value;
  const streetAddress = parseStreetAddress(combinedAddress);
  const postalStreetAddress = parseStreetAddress(studentEnrollment.postalAddressLine1);
  const currentStep = textValue(getFirstDefined(studentEnrollment, ["currentStep", "currentStepNo", "step"])).toLowerCase();
  const activeSection = {
    "1": "personal",
    "2": "personal",
    "3": "language",
    "4": "schooling",
    "5": "education",
    "6": "employment",
    "7": "disability",
    "8": "study",
    "9": "lln",
    "10": "declaration",
    usi: "personal",
    personal: "personal",
    language: "language",
    schooling: "schooling",
    education: "education",
    employment: "employment",
    disability: "disability",
    study: "study",
    lln: "lln",
    declaration: "declaration",
  }[currentStep] || "personal";

  return {
    ...initial,
    studentEnrollmentId: studentEnrollment.studentEnrollmentId ? String(studentEnrollment.studentEnrollmentId) : "",
    enrolmentNumber: textValue(studentEnrollment.enrolmentNumber),
    studentBookingId: studentEnrollment.studentBookingId ? String(studentEnrollment.studentBookingId) : "",
    usiNumber: textValue(getFirstDefined(studentEnrollment, ["usiNumber", "usiNumber", "usiNumberValue"])),
    usiPermissionGranted: studentEnrollment.usiPermissionGranted === true,
    firstName: textValue(getFirstDefined(studentEnrollment, ["firstName", "firstName"])),
    middleName: textValue(getFirstDefined(studentEnrollment, ["middleName", "middleName"])),
    lastName: textValue(getFirstDefined(studentEnrollment, ["lastName", "lastName", "last"])),
    title: getOptionName(studentEnrollment.titleId, master?.titles || [], studentEnrollment.title),
    titleId: getOptionId(studentEnrollment.titleId, master?.titles || [], studentEnrollment.title),
    dateOfBirth: dateInputValue(getFirstDefined(studentEnrollment, ["dateOfBirth", "dateOfBirth"])),
    gender: getOptionName(getFirstDefined(studentEnrollment, ["genderId", "genderNo", "sexId"]), master?.genders || [], getFirstDefined(studentEnrollment, ["gender", "sex", "genderName"])),
    genderId: getOptionId(getFirstDefined(studentEnrollment, ["genderId", "genderNo", "sexId"]), master?.genders || [], getFirstDefined(studentEnrollment, ["gender", "sex", "genderName"])),
    homePhone: textValue(getFirstDefined(studentEnrollment, ["homePhone", "homePhone"])),
    workPhone: textValue(getFirstDefined(studentEnrollment, ["workPhone", "workPhone"])),
    mobileNumber: textValue(getFirstDefined(studentEnrollment, ["mobileNumber", "mobileNumber", "mobilePhone"])),
    email: textValue(getFirstDefined(studentEnrollment, ["email", "emailAddress"])),
    preferredContactTypeId: textValue(studentEnrollment.preferredContactTypeId),
    buildingPropertyName: textValue(studentEnrollment.buildingPropertyName),
    flatUnitDetails: textValue(studentEnrollment.flatUnitDetails || studentEnrollment.addressLine2),
    addressLine1: addressLine1Value,
    streetNumber: textValue(studentEnrollment.streetNumber || streetAddress.streetNumber),
    streetName: textValue(studentEnrollment.streetName || streetAddress.streetName),
    suburb: textValue(studentEnrollment.suburb),
    postCode: textValue(getFirstDefined(studentEnrollment, ["postCode", "postCode"])),
    state: getOptionName(studentEnrollment.stateId, master?.states || [], studentEnrollment.state) || stateNameById[Number(studentEnrollment.stateId)] || "",
    stateId: getOptionId(studentEnrollment.stateId, master?.states || [], studentEnrollment.state),
    cityId: studentEnrollment.cityId || null,
    countryId: studentEnrollment.countryId || null,
    sameAsResidential: studentEnrollment.sameAsResidential !== false,
    postalBuildingPropertyName: textValue(studentEnrollment.postalBuildingPropertyName),
    postalFlatUnitDetails: textValue(studentEnrollment.postalFlatUnitDetails || studentEnrollment.postalAddressLine2),
    postalStreetNumber: textValue(studentEnrollment.postalStreetNumber || postalStreetAddress.streetNumber),
    postalStreetName: textValue(studentEnrollment.postalStreetName || postalStreetAddress.streetName),
    postalAddressLine1: textValue(getFirstDefined(studentEnrollment, ["postalType", "postalAddressLine1"])),
    postalSuburb: textValue(getFirstDefined(studentEnrollment, ["postalSuburb", "postalSuburb"])),
    postalPostCode: textValue(getFirstDefined(studentEnrollment, ["postalPostCode", "postalPostCode"])),
    postalState: getOptionName(getFirstDefined(studentEnrollment, ["postalStateId", "postalStateId"]), master?.postalStates || [], getFirstDefined(studentEnrollment, ["postalState", "postalState", "postalStateName"])) || stateNameById[Number(getFirstDefined(studentEnrollment, ["postalStateId", "postalStateId"]))] || "",
    postalStateId: getOptionId(getFirstDefined(studentEnrollment, ["postalStateId", "postalStateId"]), master?.postalStates || [], getFirstDefined(studentEnrollment, ["postalState", "postalState", "postalStateName"])),
    postalCityId: studentEnrollment.postalCityId || null,
    postalCountryId: studentEnrollment.postalCountryId || null,
    emergencyContactName: textValue(getFirstDefined(studentEnrollment, ["emergencyContactName", "emergencyContactName"])),
    emergencyRelationship: getOptionName(
      getFirstDefined(studentEnrollment, ["emergencyContactRelationshipId", "emergencyRelationshipId", "emergencyRelationshipNo"]),
      master?.emergencyRelationships || [],
      getFirstDefined(studentEnrollment, ["emergencyRelationship", "emergencyRelationship"])),
    emergencyContactRelationshipId: getOptionId(
      getFirstDefined(studentEnrollment, ["emergencyContactRelationshipId", "emergencyRelationshipId", "emergencyRelationshipNo"]),
      master?.emergencyRelationships || [],
      getFirstDefined(studentEnrollment, ["emergencyRelationship", "emergencyRelationship"])) || null,
    emergencyPhone: textValue(getFirstDefined(studentEnrollment, ["emergencyPhone", "emergencyPhone"])),
    emergencyMobile: textValue(studentEnrollment.emergencyMobile),
    countryOfBirth: getOptionName(getFirstDefined(studentEnrollment, ["countryOfBirthId", "countryOfBirthId", "mainLanguageId"]), master?.countriesOfBirth || master?.countries || [], getFirstDefined(studentEnrollment, ["countryOfBirth", "countryOfBirthName", "countryOfBirth", "countryName"])),
    countryOfBirthId: getOptionId(getFirstDefined(studentEnrollment, ["countryOfBirthId", "countryOfBirthId", "mainLanguageId"]), master?.countriesOfBirth || master?.countries || [], getFirstDefined(studentEnrollment, ["countryOfBirth", "countryOfBirthName", "countryOfBirth", "countryName"])),
    townOfBirth: textValue(getFirstDefined(studentEnrollment, ["townOfBirth", "townOfBirth"])),
    australianCitizen: boolToChoice(getFirstDefined(studentEnrollment, ["australianCitizen", "australianCitizen"])),
    indigenousStatus: getOptionName(studentEnrollment.indigenousStatusId, master?.indigenousStatus || [], studentEnrollment.indigenousStatus),
    indigenousStatusId: getOptionId(getFirstDefined(studentEnrollment, ["indigenousStatusId", "indigenousStatusId"]), master?.indigenousStatus || [], getFirstDefined(studentEnrollment, ["indigenousStatus", "aboriginal"])),
    speakOtherLanguage: boolToChoice(getFirstDefined(studentEnrollment, ["speakOtherLanguage", "speekOtherLanguage", "speaksOtherLanguage", "speakOtherLanguage"])),
    otherLanguage: textValue(getFirstDefined(studentEnrollment, ["otherLanguage", "otherLanguage"])),
    englishProficiency: getOptionName(getFirstDefined(studentEnrollment, ["englishProficiencyId", "englishProficiencyId"]), master?.englishProficiency || [], getFirstDefined(studentEnrollment, ["englishProficiency", "englishProficiency"])),
    englishProficiencyId: getOptionId(getFirstDefined(studentEnrollment, ["englishProficiencyId", "englishProficiencyId"]), master?.englishProficiency || [], getFirstDefined(studentEnrollment, ["englishProficiency", "englishProficiency"])),
    completedYear12: boolToChoice(getFirstDefined(studentEnrollment, ["completedYear12", "completedYear12"])),
    highestSchoolLevel: getOptionName(getFirstDefined(studentEnrollment, ["highestSchoolLevelId", "highestSchoolLevelId"]), master?.highestSchoolLevels || [], getFirstDefined(studentEnrollment, ["highestSchoolLevel", "highestSchoolLevel"])),
    highestSchoolLevelId: getOptionId(getFirstDefined(studentEnrollment, ["highestSchoolLevelId", "highestSchoolLevelId"]), master?.highestSchoolLevels || [], getFirstDefined(studentEnrollment, ["highestSchoolLevel", "highestSchoolLevel"])),
    schoolCountryId: getOptionId(getFirstDefined(studentEnrollment, ["schoolCountryId", "schoolCountryId"]), master?.countries || [], getFirstDefined(studentEnrollment, ["schoolCountry", "schoolCountryName"])) || null,
    schoolCompletedYear: textValue(getFirstDefined(studentEnrollment, ["schoolCompletedYear", "schoolCompletedYear"])),
    stillAttendingSecondarySchool: boolToChoice(studentEnrollment.stillAttendingSecondarySchool),
    ableToCompleteQualification: boolToChoice(getFirstDefined(studentEnrollment, ["ableToCompleteQualification", "ableToCompleteQualification"])),
    qualificationCompletedYear: textValue(getFirstDefined(studentEnrollment, ["qualificationCompletedYear", "qualificationCompletedYear"])),
    highestQualificationIds: Array.isArray(studentEnrollment.highestQualificationIds)
      ? studentEnrollment.highestQualificationIds.map(String)
      : [],
    hasConcessionCard: boolToChoice(getFirstDefined(studentEnrollment, ["hasConcessionCard", "hasConcessionCard"])),
    concessionCardNumber: textValue(getFirstDefined(studentEnrollment, ["concessionCardNumber", "concessionCardNumber"])),
    occupation: textValue(getFirstDefined(studentEnrollment, ["occupation", "occupation"])),
    employmentStatusId: getOptionId(getFirstDefined(studentEnrollment, ["employmentStatusId", "employmentStatusId"]), master?.employmentStatus || [], getFirstDefined(studentEnrollment, ["employmentStatus", "employmentStatusName"])),
    employmentStartDate: dateInputValue(getFirstDefined(studentEnrollment, ["employmentStartDate", "employmentStartDate"])),
    workingHoursPerWeek: textValue(getFirstDefined(studentEnrollment, ["workingHoursPerWeek", "workingHoursPerWeek"])),
    employerName: textValue(getFirstDefined(studentEnrollment, ["employerName", "employerName"])),
    disabilityFlag: boolToChoice(studentEnrollment.disabilityFlag),
    disabilityTypeIds: Array.isArray(studentEnrollment.disabilityTypeIds)
      ? studentEnrollment.disabilityTypeIds.map(String)
      : [],
    studyReasonIds: Array.isArray(studentEnrollment.studyReasonIds)
      ? studentEnrollment.studyReasonIds.map(String)
      : [],
    disabilitySupportRequired: textValue(getFirstDefined(studentEnrollment, ["disabilitySupportRequired", "disabilitySupportRequired"])),
    howDidYouHear: textValue(getFirstDefined(studentEnrollment, ["howDidYouHear", "howDidYouHear"])),
    courseEntryRequirementsMet: boolToChoice(studentEnrollment.courseEntryRequirementsMet),
    reasonableAdjustment: boolToChoice(getFirstDefined(studentEnrollment, ["reasonableAdjustment", "reasonableAdjustment"])),
    canReadWriteEnglish: boolToChoice(getFirstDefined(studentEnrollment, ["canReadWriteEnglish", "canReadWriteEnglish"])),
    deliveryFaceToFaceSuitable: boolToChoice(studentEnrollment.deliveryFaceToFaceSuitable),
    deliveryWorkplaceSuitable: boolToChoice(studentEnrollment.deliveryWorkplaceSuitable),
    deliveryTrainerSupportSuitable: boolToChoice(studentEnrollment.deliveryTrainerSupportSuitable),
    deliveryAssessmentRemarks: textValue(studentEnrollment.deliveryAssessmentRemarks),
    rplOrCreditTransferRequested: boolToChoice(studentEnrollment.rplOrCreditTransferRequested),
    llnSupportRequired: textValue(getFirstDefined(studentEnrollment, ["llnSupportRequired", "llnSupportRequired"])),
    usiDeclarationAccepted: Boolean(getFirstDefined(studentEnrollment, ["declarationAccepted"])),
    declarationAccepted: Boolean(getFirstDefined(studentEnrollment, ["declarationAccepted"])),
    studentSignature: textValue(getFirstDefined(studentEnrollment, ["studentSignature", "studentSignature"])),
    clientName: textValue(studentEnrollment.clientName),
    clientSignatureText: textValue(getFirstDefined(studentEnrollment, ["clientSignatureText", "clientSignatureText"])),
    clientSignatureDate: dateTimeLocalValue(studentEnrollment.clientSignatureDate),
    clientSignatureDataUrl: textValue(studentEnrollment.clientSignatureDataUrl),
    clientSignatureDocumentId: studentEnrollment.clientSignatureDocumentId || null,
    removeClientSignature: Boolean(studentEnrollment.removeClientSignature),
    staffEvidenceSubmitted: boolToChoice(studentEnrollment.staffEvidenceSubmitted),
    staffEntryRequirementsSatisfied: boolToChoice(studentEnrollment.staffEntryRequirementsSatisfied),
    staffOutcomeNotified: boolToChoice(studentEnrollment.staffOutcomeNotified),
    staffName: textValue(studentEnrollment.staffName),
    staffSignatureText: textValue(getFirstDefined(studentEnrollment, ["staffSignatureText", "staffSignatureText"])),
    staffSignatureDate: dateTimeLocalValue(studentEnrollment.staffSignatureDate),
    staffSignatureDataUrl: textValue(studentEnrollment.staffSignatureDataUrl),
    staffSignatureDocumentId: studentEnrollment.staffSignatureDocumentId || null,
    removeStaffSignature: Boolean(studentEnrollment.removeStaffSignature),
    activeSection,
  };
}

export function mapFormStateToEnrollment(form, documents = []) {
  const residentialAddress = form.addressLine1 || [form.streetNumber, form.streetName].filter(Boolean).join(" ");
  const postalStreetAddress = [form.postalStreetNumber, form.postalStreetName].filter(Boolean).join(" ");
  const sameAsResidential = form.sameAsResidential !== false;
  const postalStateId = nullableInteger(form.postalStateId);

  const enrollment = {
    tStamp: null,
    studentEnrollmentId: form.studentEnrollmentId ? Number(form.studentEnrollmentId) : 0,
    enrolmentNumber: form.enrolmentNumber || null,
    studentBookingId: form.studentBookingId ? Number(form.studentBookingId) : null,
    progressPercentage: getEnrollmentProgress(form, documents).percentage,
    currentStepNo: enrollmentSectionSteps[form.activeSection] || 1,
    currentStep: String(enrollmentSectionSteps[form.activeSection] || 1),
    isSubmitted: false,
    submittedDate: null,
    usiNumber: form.usiNumber || null,
    usiPermissionGranted: form.usiPermissionGranted === true,
    title: form.title || null,
    firstName: form.firstName || null,
    middleName: form.middleName || null,
    lastName: form.lastName || null,
    preferredName: form.firstName || null,
    genderId: nullableInteger(form.genderId),
    dateOfBirth: dateTimeOffsetValue(form.dateOfBirth),
    email: form.email || null,
    preferredContactTypeId: nullableInteger(form.preferredContactTypeId),
    mobileNumber: form.mobileNumber || null,
    homePhone: form.homePhone || null,
    workPhone: form.workPhone || null,
    buildingPropertyName: form.buildingPropertyName || null,
    flatUnitDetails: form.flatUnitDetails || null,
    streetNumber: form.streetNumber || null,
    streetName: form.streetName || null,
    addressLine1: residentialAddress || null,
    addressLine2: form.flatUnitDetails || null,
    suburb: form.suburb || null,
    postCode: form.postCode || null,
    stateId: nullableInteger(form.stateId),
    cityId: nullableInteger(form.cityId),
    countryId: nullableInteger(form.countryId),
    state: form.state || "",
    sameAsResidential,
    postalBuildingPropertyName: sameAsResidential ? (form.buildingPropertyName || null) : (form.postalBuildingPropertyName || null),
    postalFlatUnitDetails: sameAsResidential ? (form.flatUnitDetails || null) : (form.postalFlatUnitDetails || null),
    postalStreetNumber: sameAsResidential ? (form.streetNumber || null) : (form.postalStreetNumber || null),
    postalStreetName: sameAsResidential ? (form.streetName || null) : (form.postalStreetName || null),
    postalAddressLine1: sameAsResidential ? residentialAddress : postalStreetAddress,
    postalAddressLine2: sameAsResidential ? (form.flatUnitDetails || "") : (form.postalFlatUnitDetails || ""),
    postalSuburb: sameAsResidential ? (form.suburb || "") : (form.postalSuburb || ""),
    postalPostCode: sameAsResidential ? (form.postCode || "") : (form.postalPostCode || ""),
    postalStateId: postalStateId || (sameAsResidential ? nullableInteger(form.stateId) : null),
    postalCityId: sameAsResidential ? nullableInteger(form.cityId) : nullableInteger(form.postalCityId),
    postalCountryId: sameAsResidential ? nullableInteger(form.countryId) : nullableInteger(form.postalCountryId),
    postalState: sameAsResidential ? (form.state || "") : (form.postalState || ""),
    countryOfBirthId: nullableInteger(form.countryOfBirthId),
    townOfBirth: form.townOfBirth || null,
    australianCitizen: yesNoValue(form.australianCitizen),
    indigenousStatusId: nullableInteger(form.indigenousStatusId),
    indigenousStatus: form.indigenousStatus || null,
    speakOtherLanguage: yesNoValue(form.speakOtherLanguage),
    otherLanguage: form.otherLanguage || null,
    englishProficiency: form.englishProficiency || null,
    englishProficiencyId: form.englishProficiencyId ? String(form.englishProficiencyId) : "",
    completedYear12: yesNoValue(form.completedYear12),
    highestSchoolLevel: form.highestSchoolLevel || null,
    highestSchoolLevelId: form.highestSchoolLevelId ? String(form.highestSchoolLevelId) : null,
    schoolCountryId: nullableInteger(form.schoolCountryId),
    schoolCompletedYear: nullableInteger(form.schoolCompletedYear),
    stillAttendingSecondarySchool: form.stillAttendingSecondarySchool === "" ? null : yesNoValue(form.stillAttendingSecondarySchool),
    ableToCompleteQualification: form.ableToCompleteQualification === "" ? null : yesNoValue(form.ableToCompleteQualification),
    qualificationCompletedYear: yesNoValue(form.ableToCompleteQualification) ? nullableInteger(form.qualificationCompletedYear) : null,
    highestQualificationIds: (yesNoValue(form.ableToCompleteQualification) ? (form.highestQualificationIds || []) : [])
      .map(nullableInteger)
      .filter((id) => id !== null),
    hasConcessionCard: yesNoValue(form.hasConcessionCard),
    concessionCardNumber: form.concessionCardNumber || null,
    employmentStatusId: nullableInteger(form.employmentStatusId),
    occupation: form.occupation || null,
    employmentStartDate: dateTimeOffsetValue(form.employmentStartDate),
    workingHoursPerWeek: nullableInteger(form.workingHoursPerWeek),
    employerName: form.employerName || null,
    disabilityFlag: form.disabilityFlag === "" ? null : yesNoValue(form.disabilityFlag),
    disabilityTypeIds: (form.disabilityTypeIds || [])
      .map(nullableInteger)
      .filter((id) => id !== null),
    studyReasonIds: (form.studyReasonIds || []).map(nullableInteger).filter((id) => id !== null),
    disabilitySupportRequired: form.disabilitySupportRequired || null,
    howDidYouHear: form.howDidYouHear || null,
    courseEntryRequirementsMet: form.courseEntryRequirementsMet === "" || form.courseEntryRequirementsMet === null ? null : Number(form.courseEntryRequirementsMet) === YES_NO.YES,
    reasonableAdjustment: form.reasonableAdjustment === "" ? null : yesNoValue(form.reasonableAdjustment),
    canReadWriteEnglish: form.canReadWriteEnglish === "" ? null : yesNoValue(form.canReadWriteEnglish),
    deliveryFaceToFaceSuitable: form.deliveryFaceToFaceSuitable === "" ? null : yesNoValue(form.deliveryFaceToFaceSuitable),
    deliveryWorkplaceSuitable: form.deliveryWorkplaceSuitable === "" ? null : yesNoValue(form.deliveryWorkplaceSuitable),
    deliveryTrainerSupportSuitable: form.deliveryTrainerSupportSuitable === "" ? null : yesNoValue(form.deliveryTrainerSupportSuitable),
    deliveryAssessmentRemarks: form.deliveryAssessmentRemarks || null,
    rplOrCreditTransferRequested: null,
    llnSupportRequired: form.llnSupportRequired || null,
    declarationAccepted: form.declarationAccepted === true,
    declarationDate: form.declarationAccepted ? new Date().toISOString() : null,
    clientName: form.clientName || [form.firstName, form.lastName].filter(Boolean).join(" ") || null,
    clientSignatureText: form.clientSignatureText || null,
    clientSignatureDate: dateTimeOffsetValue(form.clientSignatureDate),
    clientSignatureDataUrl: form.clientSignatureDataUrl || null,
    clientSignatureDocumentId: nullableInteger(form.clientSignatureDocumentId),
    removeClientSignature: form.removeClientSignature === true,
    staffEvidenceSubmitted: form.staffEvidenceSubmitted === "" ? null : yesNoValue(form.staffEvidenceSubmitted),
    staffEntryRequirementsSatisfied: form.staffEntryRequirementsSatisfied === "" ? null : yesNoValue(form.staffEntryRequirementsSatisfied),
    staffOutcomeNotified: form.staffOutcomeNotified === "" ? null : yesNoValue(form.staffOutcomeNotified),
    staffName: form.staffName || null,
    staffSignatureText: form.staffSignatureText || null,
    staffSignatureDate: dateTimeOffsetValue(form.staffSignatureDate),
    staffSignatureDataUrl: form.staffSignatureDataUrl || null,
    staffSignatureDocumentId: nullableInteger(form.staffSignatureDocumentId),
    removeStaffSignature: form.removeStaffSignature === true,
    emergencyPhone: form.emergencyPhone || "",
    emergencyMobile: form.emergencyMobile || null,
    emergencyContactName: form.emergencyContactName || "",
    emergencyContactRelationshipId: nullableInteger(form.emergencyContactRelationshipId),
    insertedBy: "frontend",
    updatedBy: "frontend",
    userInfo: {
      insertedBy: "frontend",
      updatedBy: "frontend",
    },
  };

  return enrollment;
}

export { initial };
import { STUDENT_DOCUMENT_TYPES } from "@/constants/studentDocuments";
